module.exports = __webpack_public_path__ + "static/img/shangchengma.8f4a815.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shangchengma.jpeg
// module id = N5m2
// module chunks = 1